import { useModalStore } from '@features/modal'
import SearchModal from '@features/search/ui/modal'
import styles from '@features/search/ui/styles.module.scss'


export default function useSearchModal () {
  const { openModal, closeModal } = useModalStore()

  const openSearchModal = () => {
    openModal('search', <SearchModal />, {
      hideIconClose: true,
      classes: {
        body: styles['modal-body'],
        content: styles['modal-content'],
      },
    })
  }

  const closeSearchModal = () => {
    closeModal('search')
  }

  return {
    openSearchModal,
    closeSearchModal,
  }
}
